import React from "react";
import { steps } from "../data/content";
export function HowItWorks() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-76" data-mp="7slqt16is5sn">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="7u6k6nh3liox">
        <h2 className="text-center font-display text-3xl uppercase text-cream sm:text-5xl" data-id="element-78" data-mp="3pyroqzddcubm">
          Simple comme <span className="text-gold" data-id="element-79" data-mp="3tzjwtpai8t6b">1, 2, 3</span>
        </h2>
        <ol className="mt-10 grid gap-8 sm:mt-14 md:grid-cols-3 md:gap-10" data-id="element-80" data-mp="3u266bugyhir6">
          {steps.map((s, i) => <li key={s.title} className="flex gap-5 border-t-2 border-gold pt-5 md:block md:pt-6" data-id="element-81" data-mp="qjd6ekh3osfh" data-mpi={i}>
              <span className="font-display text-4xl text-gold md:text-5xl" data-id="element-82" data-mp="cryaxe60ayrj">{i + 1}</span>
              <div data-id="element-83" data-mp="cq5dmpha9qw7">
                <h3 className="text-xl font-bold text-cream md:mt-3 md:text-2xl" data-id="element-84" data-mp="gtbj3uwkne1m">{s.title}</h3>
                <p className="mt-1 text-mute md:mt-2" data-id="element-85" data-mp="14je6vytgdxuf">{s.desc}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}